<template>
  <div>
    <div class="row1" style="padding-right: 10px;">
      <div>
		<el-button
		  @click="back"
		  class="row-btn add"
		  style="width: 100px;margin-bottom: 4px;"
		  type="primary"
		  size="small"
		  >返回</el-button
		>
		<!-- <el-button
		  @click="onReserve"
		  class="row-btn add"
		  type="primary"
		  size="small"
		  >预留</el-button
		> -->
		<el-button
		  @click="onCreateOrder"
		  class="row-btn"
			  style="width: 150px;margin-left: 0;"
		  type="primary"
		  size="small"
		  >生成特殊占用订单</el-button
		>
		<el-button
		  @click="onDel"
		  class="row-btn del"
			  style="width: 100px;margin-left: 0;"
		  type="primary"
		  size="small"
		  >删除</el-button
		>
	  </div>
    </div>
    <div class="tab-box">
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"> </el-table-column>
        <el-table-column label="序号"  align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
		<el-table-column prop="create_time" label="站名">
			<template slot-scope="scope">{{ scope.row.name }}</template>
		</el-table-column>
    	<el-table-column prop="create_time" label="新编号"> 
    		<template slot-scope="scope">{{ scope.row.new_number }}</template>
    	</el-table-column>
    	<el-table-column prop="create_time" label="编号"> 
    		<template slot-scope="scope">{{ scope.row.number }}</template>
    	</el-table-column>
    	<el-table-column prop="create_time" label="级别"> 
    		<template slot-scope="scope">{{ scope.row.grade.text }}</template>
    	</el-table-column>
    	<el-table-column prop="create_time" label="方位">
    		<template slot-scope="scope">{{ scope.row.direction.text }}</template>
    	</el-table-column>
    	<el-table-column label="投放形式">
			<template slot-scope="scope">{{ scope.row.scroll.text }}</template>
    	</el-table-column>
		<el-table-column label="亮灯情况">
			<template slot-scope="scope">{{ scope.row.light.text }}</template>
		</el-table-column>
    	<el-table-column prop="create_time" label="预留时间" width="200"> 
    		<template slot-scope="scope">{{ scope.row.start_time }}至{{ scope.row.end_time }}</template>
    	</el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="15"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<!-- 备注弹框 -->
	<el-dialog title="备注" :visible.sync="dialogFormVisible" width="25%">
	  <el-form>
	    <el-form-item label="备注内容">
	      <el-input
	        v-model="editRemarksVal"
	        autocomplete="off"
	        placeholder="请输入备注内容"
	      ></el-input>
	    </el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button @click="dialogFormVisible = false">取 消</el-button>
	    <el-button type="primary" @click="onEditRemark"
	      >确 定</el-button
	    >
	  </div>
	</el-dialog>
  </div>
</template>

<script>
// import tabDialog from "../../components/dialog/order/more.vue";
// import reserveDg from "../../components/dialog/site/reserve.vue";
export default {
  components: {
    // tabDialog,
    // reserveDg
  },
  data() {
    return {
		ids:[],
      options: [
      ],
      tagArr:[],
      value: "",
	  date:'',
      // 搜索数据对象
      searchObj: {
        light: "",//亮灯情况
		scroll: "",//投放形式
		direction: "",//方位
		grade: "",//等级
		name: "",//关键字
		// periphery: [],//周边标签
		district:'',//区域
		number:'',//品牌
		category:''//类型
      },
      editRemarksVal: "", //备注内容
      dialogFormVisible: false,
      tableData: [
      ],
	  pageObj: {
	  	limit: 15,
	  	page: 1,
		filter: {},
		op: {},
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
     
	  rObj:{
	  	direction:[],
	  	grade:[],
	  	scroll:[],
	  	warehouse:[],
	  	light:[],
	  	category:[],
	  	user:[]
	  },
	  isEditback:false,
	  isSearch:false,
	  conditionObj:{}
    };
  },
  created() {
	  let conditionObj = localStorage.getItem('conditionObj')
	  if(conditionObj){
		  conditionObj = JSON.parse(conditionObj)
		  if(conditionObj.pageObj){
			  this.pageObj = conditionObj.pageObj
		  }
		  if(conditionObj.searchObj){
			  this.searchObj = conditionObj.searchObj
		  }
		  if(conditionObj.options){
			  this.options = conditionObj.options
		  }
	  }
	  // this.currentPage = this.pageObj.page
	  this.getList();
	  // this.getConfig()
  },
  methods: {
	  // 生成订单
	  onCreateOrder(){
		  let points = localStorage.getItem('myPoints')
		  points = JSON.parse(points)
		  if(!points.length) return this.$message.error('无点位可生成订单！')
		  this.$confirm('确认生成订单？', '提示').then(() => {
			  this.dialogFormVisible = true;
		  })
	  },
	  onEditRemark(){
		  let points = localStorage.getItem('myPoints')
		  points = JSON.parse(points)
		  let obj = {
			   content:JSON.stringify(points),
			   special_remark:this.editRemarksVal
		  }
		  this.$api2.createOtherOrder(obj).then((res)=>{
		  		if(res.code == 1){
					this.dialogFormVisible = false;
		  			this.$message.success(res.msg)
		  		}else{
		  			this.$message.error(res.msg)
		  		}
		  	}).catch(()=>{})
		  console.log(obj);
	  },
	  back(){
		  this.$router.go(-1)
	  },
	  changeDate(e){
		  console.log(this.searchObj.date);
		  this.pageObj.start_time = this.date[0]
		  this.pageObj.end_time = this.date[1]
	  },
    handleReserve(){

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [0, 0];
        } else if (columnIndex === 1) {
          return [1, 12];
        }
      }
    },
    //删除
    onDel() {
      if (!this.multipleSelection.length) return this.$message.error("请勾选要删除的选项！");
	  let ids = []
	  this.multipleSelection.forEach((v,k)=>{
	  	if(v.id){
	  		ids.push(v.id)
	  	}
	  })
	  let points = localStorage.getItem('myPoints')
	  points = JSON.parse(points)
	  this.$confirm('确认删除？', '提示').then(() => {
		  let newArr = []
		  console.log(points);
		  // console.log(ids.length);
		  for(let i = 0;i<points.length;i++){
			  for(let j = 0;j<ids.length;j++){
				  if(points[i].id == ids[j]){
					  points.splice(i,1)
				  }
			  }
		  }
		  console.log(points);
		  
		  localStorage.setItem('myPoints',JSON.stringify(points))
		  this.getList()
	  }).catch(()=>{})
    },
    // 获取数据列表
    getList() {
		this.loading = true;
		let ids = localStorage.getItem('myPoints')
		ids = JSON.parse(ids)
		if(!ids){
			this.total = 0
			this.tableData = []
			this.loading = false;
			return
		}
		this.ids = ids
		let newIds = []
		ids.forEach((v,k)=>{
			newIds.push(v.id)
		})
		newIds = newIds.toString()
		this.pageObj.ids = newIds
      this.$api2.getAds(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
			this.currentPage = this.pageObj.page
      		this.total = res.count;
			res.data.forEach((v,k)=>{
				ids.forEach((item,index)=>{
					if(v.id == item.id){
						res.data[k].start_time = item.start_time
						res.data[k].end_time = item.end_time
					}
				})
			})
			this.tableData = res.data;
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/public.scss";
.join-btn{
	padding: 10px;
}
</style>